import React from 'react'
import ReactDOM from 'react-dom/client'
import './global.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from 'store'
import { ToastContainer } from 'react-toastify'
import { ConfigProvider } from 'antd'
import ja_JP from 'antd/es/locale/ja_JP'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  // <React.StrictMode>
  // </React.StrictMode>
  <Provider store={store} >
    <ConfigProvider
      locale={ja_JP}
    >
      <ToastContainer autoClose={1500} />
      <BrowserRouter>
        <App />

      </BrowserRouter>
    </ConfigProvider>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
